import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="file-upload"
export default class extends Controller {
  static targets = ["input", "filename"];

  select() {
    const file = this.inputTarget.files[0];
    if (file) {
      this.filenameTarget.textContent = file.name;
      this.filenameTarget.classList.remove("hidden");
    } else {
      this.filenameTarget.classList.add("hidden");
    }
  }
}
